import React from "react"
import Text from "@amzn/meridian/text";
import {TextProps} from "src/interfaces/props/CommonProps";

export class SmallText extends React.Component<TextProps> {

    constructor(props: TextProps) {
        super(props);
    }

    render() {
        return(
            <Text type="b300" color={this.props.color} breakWord={this.props.breakWord}> {this.props.text} </Text>
        );
    }
}

export default SmallText;
